export enum AppColors {
  RED = "rgb(237, 28, 36)",
  WHITE = "#fff",
  BLACK = "#000",
} 